import { useSelector } from 'react-redux';
import { RootState } from '../../utils/store';

export const useModuleAccess = (moduleName: string) => {
  const modules = useSelector((state: RootState) => state?.auth?.userModules);
  const matched = modules?.find((m) => m?.module_name?.toLowerCase() === moduleName?.toLowerCase());

  return {
    canView: matched?.permission_view === 1,
    canEdit: matched?.permission_edit === 1,
    hasAccess: matched?.permission_view === 1 || matched?.permission_edit === 1,
  };
};
